import { Routes, Route } from "react-router-dom";
import HomeRoute from "./HomeRoute";
import ThemeRoute from "./ThemeRoute";
import ResetPassword from "../views/ResetPassword";
import PageNotFound from "../views/PageNotFound";
import { Navigate, useRoutes } from "react-router-dom";
import MainRoutes from "./MainRoutes";
import Login from "../views/Login";
import Register from "../views/Register";
import TestRoutes from "./TestRoutes";
import DemoRoutes from "./DemoRoutes";
import QuestionnaireRoutes from "./QuestionnaireRoutes";
import LogoutPage from "../views/LogoutPage";
import TemiRoutes from "./TemiRoutes";
import SteaminpeRoute from "./SteminpeRoute";
import ContactUs from "../views/ContactUs";
import BodyInfoList from "../views/BodyInfoList";
// import PageNotFoundRoute from "./PageNotFoundRoute";
import AICoachPlatformSupport from "../views/AICoachPlatformSupport";
import AICoachPlatformPrivacy from "../views/AICoachPlatformPrivacy";
import SteminPeSupport from "../views/SteminPeSupport";
import SteminPePrivacy from "../views/SteminPePrivacy";
import GuestHealthReport from "../views/GuestHealthReport";
import Dashboard from "../views/Dashboard";

// console.debug("env", process.env.NODE_ENV); 
// if (process.env.NODE_ENV === 'production') {
//   // route.children.push({ path: 'accountHelper', element: <TestAccountHelper /> });
//   route = {};
// }

export default function Router() {
    // console.debug("env: ", process.env);
    const routes = useRoutes([
        // MainRoutes,
        // DemoRoutes,
        // TemiRoutes,
        // SteaminpeRoute,

        //   {
        //     path: '/',
        //     // element: <DashboardLayout />,
        //     children: [
        //       { element: <Navigate to="/home" />, index: true },
        //       { path: 'home', element: <HomePage /> },
        //       { path: 'skill-list/:event_id', element: <SkillListPage /> },
        //       { path: 'skill-input/:skill_code', element: <SkillInputPage /> },
        //       { path: 'demo', element: <DemoPage /> },
        //     ],
        //   },
        {
            path: "/dashboard",
            element: <Dashboard />,
        },
        {
            path: '/',
            element: <Dashboard />,
        },
       
        (process.env.NODE_ENV === 'production') ? {} : TestRoutes,
       
        {
            // element: <SimpleLayout />,
            path: "/",
            children: [
                // { element: <Navigate to="/dashboard/app" />, index: true },
                { path: "404", element: <PageNotFound /> },
                { path: "*", element: <Navigate to="/404" /> },
            ],
        },
    
        // TestRoutes,
        {
            path: "*",
            element: <Navigate to="/404" replace />,
        },
    ]);

    return routes;
}

// export default function Router() {
//     return (
//         <Routes>
//             {/* Login And Register */}
//             {LoginRoute}
//             {/* Home, Member Event */}
//             {HomeRoute}
//             {/* Theme */}
//             {ThemeRoute}
//             {/* Testing  */}
//             {TestRoute}
//             {PageNotFoundRoute}
//         </Routes>
//     );
// }
